<template>
  <div class="property-container">
    <div class="sku-wrap">
      <el-table
        :data="skus"
        style="width: 100%">
        <el-table-column
          v-for="(item,index) in theadList"
          :key="index"
          :label="item.label"
        >
          <template slot-scope="scope">
            <div>{{handlePropValueRender(item.label, scope.$index)}}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="原价（元）"
          width="160">
          <template slot-scope="scope">
            <span>{{scope.row.price}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="活动价（元）"
          width="160">
          <template slot="header">
            <p><span style="color: #f00;">*</span> 活动价（元）</p>
          </template>
          <template slot-scope="scope">
            <div><el-input v-model="scope.row.activity_price" :disabled="readonly" @change="handleSkuSave"></el-input></div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>

export default {
  name: "property",
  props: {
    content: {
      type: Object,
      default: () => {return {}}
    },
    readonly: false
  },
  watch: {
    content(val) {
      this.init(val)
    }
  },
  data() {
    return {
      properties: [],
      skus: [],
      theadList: [],
    }
  },
  created() {
    this.init(this.content)
  },
  methods: {
    init(val) {
      if (val) {
        if (val.skus) {
          this.skus = val.skus
        }
        if (val.properties) {
          this.properties = val.properties

          // 初始化动态规格项计算
          this.handleSkuCompute()
        }
      }
    },
    // 自定义规格名称渲染
    handlePropValueRender(key, index) {
      const sku = this.skus[index]
      if (sku) {
        const val = sku.properties.find(v => v.key == key)
        if (val) {
          return val['val']
        }
      }
      return ''
    },
    // 根据规格值计划sku
    handleSkuCompute() {
      this.theadList = this.properties.map(v => ({label: v.name, prop: v.id}))
    },
    // 保存sku数据
    handleSkuSave() {
      this.$emit('save', {
        prices: this.skus.map(v => {
          return {
            product_id: v.product_id,
            sku_id: v.id,
            price: v.activity_price
          }
        })
      })
    },
  }
};
</script>

<style scoped lang="less">
.property-container {

  .property-wrap,
  .sku-wrap {
    background-color: #fff;
    padding: 10px;
    border: 1px solid #e5e5e5;
  }
  .prop-group {

    & + .prop-group {
      margin-top: 20px;
    }
  }
  .prop-title {
    position: relative;
    display: flex;
    background: #f8f8f8;
    padding: 7px 10px;

    &:hover {
      .prop-remove {
        display: block;
      }
    }

    .value {
      width: 150px;
    }
  }
  .prop-remove,
  .prop-value-remove {
    display: none;
    position: absolute;
    top: 12px;
    right: 12px;
    font-size: 20px;
    cursor: pointer;
  }
  .prop-value-remove {
    top: 0;
    right: 0;
  }
  .prop-container {
    display: flex;
    padding: 10px 10px 0;

    .value {
      width: 150px;
    }
  }
  .prop-list {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }
  .prop-item {
    position: relative;
    padding: 5px 5px 5px 0;

    &:hover {
      .prop-value-remove {
        display: block;
      }
    }
  }
  /deep/ .el-table th {
    background-color: #fff !important;
    padding: 5px 0;
  }
}
</style>
